import { useLanguages, convertToTranslationFormat } from '../hooks/useLanguages'

interface LanguageTabsProps {
  activeTab: string
  onTabChange: (languageCode: string) => void
  translations: Record<string, { name: string; description: string }>
}

export function LanguageTabs({ activeTab, onTabChange, translations }: LanguageTabsProps) {
  // Use dynamic languages from database
  const { languages: dynamicLanguages } = useLanguages()
  const SUPPORTED_LANGUAGES = convertToTranslationFormat(dynamicLanguages)

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8 px-6">
        {SUPPORTED_LANGUAGES.map((language) => {
          const translation = translations[language.code]
          const hasContent = translation?.name && translation?.description
          
          return (
            <button
              key={language.code}
              type="button"
              onClick={() => onTabChange(language.code)}
              className={`py-2 px-1 border-b-4 font-medium text-sm relative ${
                activeTab === language.code
                  ? 'border-gray-800 text-gray-900'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } ${hasContent ? 'opacity-100' : 'opacity-40'}`}
            >
              <div className="flex items-center space-x-2">
                <span>{language.flag}</span>
                <span>{language.name}</span>
              </div>
            </button>
          )
        })}
      </nav>
    </div>
  )
}